import { Api } from "../config/request";

export default {
  getDriverTagsList(queryParams) {
    return Api.get(`/tag${queryParams}`);
  },
  getDriverTagsMappingList(queryParams) {
    return Api.get(`/tag-mapping${queryParams}`);
  },
  getDriverTag(id) {
    return Api.get(`/tag/${id}`);
  },
  createDriverTag(url, payload) {
    return Api.post(url, payload);
  },
  updateDriverTag(id, payload) {
    return Api.put(`/tag/${id}`, payload);
  },
};
